export default __webpack_public_path__ + "fc9a2ebb76cd53f1e053aa0c352b1f9b.png";